import React, { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import {
  Badge,
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Row,
} from "reactstrap"
import { FaPlus, FaX } from "react-icons/fa6"
import Configs from "../../config"
import Breadcrumb from "../../components/Common/Breadcrumb"
import Swal from "sweetalert2"
import { fetchData, FetchPutData } from "utils/Common_api_functions"
import Loader from "components/Loader/loader"
import moment from "moment"
import countryList from "react-select-country-list"
import Select from "react-select"
import { customStyles } from "utils/SelectStyles"

const EditUser = () => {
  const navigate = useNavigate()
  const { slug } = useParams()

  const [clubData, setClubData] = useState([])
  const [planData, setPlanData] = useState([])
  const [loading, setloading] = useState(false)
  const [clubName, setClubName] = useState("")
  const [errors, setErrors] = useState({})
  const [countryOptions, setCountryOptions] = useState([])
  const [answers, setanswers] = useState([])

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    club: "",
    birthdate: "",
    gender: "",
    country: "",
    postcode: "",
    trainingStartDate: "",
    plan: "",
  })

  useEffect(() => {
    setCountryOptions(countryList().getData())
    getClubs()
  }, [])

  useEffect(() => {
    getuserdata()
  }, [countryOptions])

  async function getClubs() {
    const APIData2 = await fetchData(setloading, "pricing/plan")
    const APIdata = await fetchData(setloading, "club")

    setPlanData(
      APIData2.userPlans?.map(item => ({
        label: item?.planName,
        value: item?._id,
      }))
    )

    setClubData(
      APIdata?.clubs?.map(item => ({
        label: item?.clubName,
        value: item?._id,
      }))
    )
  }

  async function getuserdata() {
    const APIData = await fetchData(setloading, `user/${slug}`)
    if (APIData?.success) {
      setFormData({
        name: APIData?.user?.name || "",
        email: APIData?.user?.email || "",
        club: APIData?.user?.club?._id || "",
        birthdate: APIData?.user?.birthdate || "",
        gender: APIData?.user?.gender || "",

        country:
          countryOptions.find(option => option.label === APIData?.user.country)
            ?.value ||
          countryOptions.find(option => option.value === APIData?.user.country)
            ?.value ||
          null,
        postcode: APIData?.user?.postcode || "",
        trainingStartDate: APIData?.user?.trainingStartDate
          ? moment(APIData?.user?.trainingStartDate).format("YYYY-MM-DD")
          : "",
        plan: APIData?.user?.plan?._id || "",
      })
      setanswers(APIData?.user?.qna)
      setClubName(APIData?.user?.club?.clubName)
    }
  }

  const handleChange = async e => {
    const { name, value } = e.target

    // Confirmation only for trainingStartDate
    if (name === "trainingStartDate") {
      // If already has a date and changing it
      if (formData.trainingStartDate && formData.trainingStartDate !== value) {
        const result = await Swal.fire({
          title: "Are you sure?",
          html: `<span class="text-danger">
          Changing the training start date will remove all workout data 
          and it may affect the league points.
        </span>`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, change it",
          cancelButtonText: "Cancel",
        })

        // If user clicked Cancel → stop here
        if (!result.isConfirmed) {
          return
        }
      }
    }

    // If confirmed or it's not trainingStartDate
    setFormData(prev => ({ ...prev, [name]: value }))
    setErrors(prev => ({ ...prev, [name]: "" }))
  }

  const handleCountryChange = selected => {
    setFormData(prev => ({
      ...prev,
      country: selected?.value || "",
    }))
    setErrors(prev => ({ ...prev, country: "" }))
  }

  const validateForm = () => {
    let tempErrors = {}
    if (!formData.name.trim()) tempErrors.name = "Name is required"
    if (!formData.email.trim()) tempErrors.email = "Email is required"
    if (!formData.club) tempErrors.club = "Club selection is required"
    if (!formData.birthdate) tempErrors.birthdate = "Birthdate is required"
    if (!formData.gender) tempErrors.gender = "Gender is required"
    if (!formData.plan) tempErrors.plan = "Plan selection is required"
    if (!formData.trainingStartDate)
      tempErrors.trainingStartDate = "Training start date is required"
    if (!formData.country) tempErrors.country = "Country is required"
    if (!formData.postcode.trim()) tempErrors.postcode = "Postcode is required"

    setErrors(tempErrors)
    return Object.keys(tempErrors).length === 0
  }

  const handleSubmit = async () => {
    if (!validateForm()) return

    const APIData = await FetchPutData(setloading, `user`, slug, formData)
    if (APIData?.data?.success) {
      Swal.fire({
        title: "User Updated Successfully.",
        icon: "success",
      })
      navigate(`${Configs.appurl}users`)
    } else {
      Swal.fire({
        title: "Failed to update User",
        text: APIData?.response?.data?.message,
        icon: "error",
      })
    }
  }

  return (
    <div className="page-content">
      {loading && <Loader />}
      <Container fluid>
        <Breadcrumb title="Users" breadcrumbItem="Edit User" />

        <Row>
          <Col lg="12">
            <Card>
              <CardBody>
                <div className="d-flex justify-content-between align-items-center">
                  <h4 className="text-black fw-bold ps-1 mb-0">Edit User</h4>
                  <div className="d-flex gap-3">
                    <button className="btn btn-add" onClick={handleSubmit}>
                      <FaPlus className="me-1" size={14} />
                      Submit
                    </button>
                    <button
                      className="btn bg-danger text-white"
                      onClick={() => navigate(-1)}
                    >
                      <FaX className="me-1" size={14} />
                      Cancel
                    </button>
                  </div>
                </div>

                <div className="Seprator" />

                <Row className="mt-4">
                  <Col md="4">
                    <Label>
                      Name <span className="text-danger">*</span>
                    </Label>
                    <Input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Enter full name"
                    />
                    {errors.name && (
                      <small className="text-danger">{errors.name}</small>
                    )}
                  </Col>

                  <Col md="4">
                    <Label>
                      Email <span className="text-danger">*</span>
                    </Label>
                    <Input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Enter email"
                      disabled
                    />
                    {errors.email && (
                      <small className="text-danger">{errors.email}</small>
                    )}
                  </Col>

                  <Col md="4">
                    <Label>
                      Select Club <span className="text-danger">*</span>
                    </Label>
                    <Input
                      type="select"
                      name="club"
                      value={formData.club}
                      onChange={handleChange}
                    >
                      <option value="">Select Club</option>
                      {clubData.map(club => (
                        <option key={club.id} value={club.value}>
                          {club.label}
                        </option>
                      ))}
                    </Input>
                    {errors.club && (
                      <small className="text-danger">{errors.club}</small>
                    )}
                  </Col>
                </Row>

                <Row className="mt-4">
                  <Col md="4">
                    <Label>
                      Birth Date <span className="text-danger">*</span>
                    </Label>
                    <Input
                      type="date"
                      name="birthdate"
                      value={formData.birthdate}
                      onChange={handleChange}
                    />
                    {errors.birthdate && (
                      <small className="text-danger">{errors.birthdate}</small>
                    )}
                  </Col>

                  <Col xl="4">
                    <Label>
                      Gender <span className="text-danger">*</span>
                    </Label>
                    <Input
                      type="select"
                      name="gender"
                      value={formData?.gender}
                      onChange={handleChange}
                      className="form-control"
                    >
                      <option value="">Select Gender</option>
                      <option value="male">Male</option>
                      <option value="female">Female</option>
                      <option value="nonbinary">Non-Binary</option>
                      <option value="prefer_not_say">Prefer not to say</option>
                      <option value="other">Other</option>
                    </Input>
                    {errors.gender && (
                      <small className="text-danger">{errors.gender}</small>
                    )}
                  </Col>

                  <Col xl="4">
                    <Label>
                      Plan <span className="text-danger">*</span>
                    </Label>
                    <Input
                      type="select"
                      name="plan"
                      value={formData?.plan}
                      onChange={handleChange}
                      className="form-control"
                    >
                      <option value="">Select Plan</option>
                      {planData.map(club => (
                        <option key={club.id} value={club.value}>
                          {club.label}
                        </option>
                      ))}
                    </Input>
                    {errors.plan && (
                      <small className="text-danger">{errors.plan}</small>
                    )}
                  </Col>

                  <Col md="4" className="mt-4">
                    <Label>
                      Training Start Date <span className="text-danger">*</span>
                    </Label>
                    <Input
                      type="date"
                      name="trainingStartDate"
                      value={formData?.trainingStartDate}
                      onChange={handleChange}
                    />
                    {errors.trainingStartDate && (
                      <small className="text-danger">
                        {errors.trainingStartDate}
                      </small>
                    )}
                  </Col>

                  <Col md="4" className="mt-4">
                    <Label>
                      Country <span className="text-danger">*</span>
                    </Label>
                    <Select
                      options={countryOptions}
                      value={
                        countryOptions.find(
                          option => option.value === formData.country
                        ) || null
                      }
                      styles={customStyles}
                      onChange={handleCountryChange}
                      placeholder="Select Country"
                    />
                    {errors.country && (
                      <small className="text-danger">{errors.country}</small>
                    )}
                  </Col>

                  <Col md="4" className="mt-4">
                    <Label>
                      PostCode <span className="text-danger">*</span>
                    </Label>
                    <Input
                      type="text"
                      name="postcode"
                      value={formData?.postcode}
                      onChange={handleChange}
                      placeholder="Enter PostCode"
                    />
                    {errors.postcode && (
                      <small className="text-danger">{errors.postcode}</small>
                    )}
                  </Col>
                </Row>

                {/* Preferences Section */}
                <Row className="mx-1 mt-4">
                  <h4 className="text-black fw-bold ps-1 mb-0">
                    User Preferences
                  </h4>
                  <div className="Seprator" />
                  <Col md={12}>
                    <Card className="shadow-sm border-0">
                      <CardBody>
                        <Row>
                          <Col md={6} className="mb-4">
                            <h5 className="fw-bold">
                              1. Why have you signed up to Fans To 5K?
                            </h5>
                            {Array.isArray(answers?.[0]?.answer)
                              ? answers[0].answer.map((item, index) => (
                                  <Badge
                                    key={index}
                                    color="info"
                                    className="me-2 mb-2 fs-6 p-2 mt-2"
                                  >
                                    {item}
                                  </Badge>
                                ))
                              : answers?.[0]?.answer && (
                                  <Badge
                                    color="info"
                                    className="me-2 mb-2 fs-6 p-2 mt-2"
                                  >
                                    {answers[0].answer}
                                  </Badge>
                                )}
                          </Col>

                          <Col md={6} className="mb-4">
                            <h5 className="fw-bold">
                              2. How can Fans To 5K support you?
                            </h5>
                            {Array.isArray(answers?.[6]?.answer)
                              ? answers[6].answer.map((item, index) => (
                                  <Badge
                                    key={index}
                                    color="info"
                                    className="me-2 mb-2 fs-6 p-2 mt-2"
                                  >
                                    {item}
                                  </Badge>
                                ))
                              : answers?.[6]?.answer && (
                                  <Badge
                                    color="info"
                                    className="me-2 mb-2 fs-6 p-2 mt-2"
                                  >
                                    {answers[6].answer}
                                  </Badge>
                                )}
                          </Col>

                          <Col md={6} className="mb-4">
                            <h5 className="fw-bold">
                              3. Are you currently exercising?
                            </h5>
                            <div className="d-flex gap-3 align-items-center">
                              <Badge
                                color="success"
                                className="fs-6 p-2 mt-2 h-auto mb-0"
                              >
                                {answers?.[1]?.answer}
                              </Badge>
                              <div>
                                <span className="text-muted small fs-6">
                                  Duration:
                                </span>{" "}
                                <Badge
                                  color="secondary"
                                  className="fs-6 p-2 mb-0"
                                >
                                  {answers?.[2]?.answer}
                                </Badge>
                              </div>
                              {/* <div>
                                <span className="text-muted small fs-6">
                                  Frequency:
                                </span>{" "}
                                <Badge
                                  color="secondary"
                                  className="fs-6 p-2 mb-0"
                                >
                                  {answers?.[3]?.answer}
                                </Badge>
                              </div> */}
                            </div>
                          </Col>

                          <Col md={6} className="mb-4">
                            <h5 className="fw-bold">
                              4. Have you ever completed a parkrun?
                            </h5>
                            <Badge
                              color="success"
                              className="me-2 mb-2 fs-6 p-2 mt-2"
                            >
                              {answers?.[4]?.answer}
                            </Badge>
                            <Badge
                              color="secondary"
                              className="me-2 mb-2 fs-6 p-2"
                            >
                              {answers?.[5]?.answer}
                            </Badge>
                          </Col>

                          <Col md={6} className="mb-4">
                            <h5 className="fw-bold">
                              5. When was the last time you attended a match of{" "}
                              {clubName}?
                            </h5>
                            <Badge
                              color="primary"
                              className="me-2 mb-2 fs-6 mt-2 p-2"
                            >
                              {answers?.[7]?.answer}
                            </Badge>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default EditUser
